export default function PrivacyPage() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <h1>Privacy Policy</h1>
      <p><em>Last updated: {new Date().toLocaleDateString()}</em></p>
      
      <h2>1. Introduction</h2>
      <p>
        Welcome to Social Crossposter. We respect your privacy and are committed to protecting 
        your personal data. This privacy policy explains how we collect, use, and store 
        information when you use our service.
      </p>

      <h2>2. Account Connections & Authentication</h2>
      <p>
        Our service allows you to connect external social media accounts, including Facebook and TikTok.
        When you connect these accounts, we use standard OAuth authorization protocols. 
      </p>
      <ul>
        <li><strong>Secure Storage:</strong> The OAuth access tokens and refresh tokens provided by these platforms are securely encrypted before being stored in our database. They are never exposed publicly or sent to the frontend application.</li>
        <li><strong>Account Disconnection:</strong> You retain full control over your connected accounts. You can disconnect any connected Facebook or TikTok account at any time through our dashboard, which will delete the associated stored data and tokens from our systems.</li>
      </ul>

      <h2>3. Video Uploads & Publishing</h2>
      <p>
        Social Crossposter provides functionality to upload video files directly to your connected social media profiles (immediate publishing only; no scheduling is supported). 
        Uploaded videos are processed strictly for the purpose of transmitting them to the social platforms you select. We do not use your videos for any other purpose, nor do we publicly host or claim ownership of your content.
      </p>

      <h2>4. Data Minimization</h2>
      <p>
        We only request the minimum required permissions (scopes) from Facebook and TikTok necessary to facilitate immediate direct video publishing and to display your basic profile information (such as your display name and avatar) within our dashboard.
      </p>

      <h2>5. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page.
      </p>
    </div>
  );
}
